import { Injectable } from "@angular/core";
import { ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { DefaultSettingsService } from './Shared/default-settings.service';
import { CompanySettingService } from './Shared/company-setting.service';

@Injectable({
  providedIn: 'root'
})
export class LoadSettingResolver {
  constructor(private defaultSettingsService: DefaultSettingsService, private companySettingService: CompanySettingService) { }

  async resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Promise<any> {
    try {
      // Load settings and wait for the result
      return (this.defaultSettingsService.loadSettings());

    } catch (error) {
      console.error('Error loading default settings:', error);
      return null; // Provide fallback behavior if needed
    }
  }
}
